/* SK B2B Hero - traer el mensaje de gracias a la vista tras enviar (CH001).
   La validacion del checkbox es nativa (required + input enfocable, ver CSS). */
(function () {
  'use strict';

  /* Al enviar, Shopify recarga la pagina con el mensaje de exito. Como el
     formulario esta abajo, el mensaje queda fuera de vista: lo centramos y enfocamos. */
  var success = document.getElementById('sk-b2b-hero-form-success');
  if (!success) return;

  window.requestAnimationFrame(function () {
    success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    try { success.focus({ preventScroll: true }); } catch (e) { success.focus(); }
  });
})();
